const SocialMedia = () => {

    return (
        <div className="home__social fade-in-left">
            <a href="https://www.linkedin.com/in/maria-somoza-jurado/" className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-linkedin"></i>
            </a>
            <a href="https://github.com/MariaSJ" className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-github"></i>
            </a>
            <a href="https://twitter.com/MariaEseJota" className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-twitter"></i>
            </a> 
        </div>
    );
}

export default SocialMedia;